import { Component } from '@angular/core';
import { HomeService } from 'src/app/pages/home/services/home.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent {
  instaUrl: string = '';
  facebookUrl: string = '';
  xUrl: string = '';
  whatsappUrl: string = '';
  whatsappNumber: string = '';
  email: string = '';
  constructor(private readonly configService: HomeService) {}
  ngOnInit() {
    this.configService.getConfig('en').subscribe((data) => {
      this.facebookUrl = data.facebookUrl;
      this.instaUrl = data.instaUrl;
      this.whatsappUrl = data.whatsappUrl;
      this.xUrl = data.xUrl;
      this.email = data.email;
      this.whatsappNumber = this.extractFormattedPhone(data.whatsappUrl);
      console.log(data.whatsappUrl);
    });
  }

  extractFormattedPhone(url: string): string {
    try {
      const parsedUrl = new URL(url);
      const phone = parsedUrl.searchParams.get('phone');

      if (!phone) {
        return 'Invalid phone number';
      }

      const raw = phone.replace('+', '');

      if (raw.startsWith('20') && raw.length === 12) {
        const countryCode = '+20';
        const operator = raw.slice(2, 4);
        const rest = raw.slice(4);

        return `${countryCode} ${operator} ${rest.slice(0, 4)} ${rest.slice(4)}`;
      }

      return phone;
    } catch {
      return 'Invalid URL';
    }
  }
}
